import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from '../components/buying/LeftMenu';
import Feature from '../components/buying/Feature';
import ContactUs from '../components/ContactUs';
import BuyForOfferMachine from '../components/BuyForOfferMachine';

const BuyNowProcess = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('buying'),
      url: '/content/buying/before-bidding',
    },
    {
      label: 'Hemen Al Süreci',
      url: '/content/buying/buy-now-process',
    },
  ];

  const items = [
    {
      title: 'Online Teklif Kolaylığı',
      description: 'iyiMakina.com kullanıcıları; bilgisayarları, cep telefonları veya tabletleri aracılığıyla açık artırmalara istediği yerden, istediği saatte online olarak katılabilirler.',
      icon: 'fa-solid fa-hand-holding-dollar',
    },
    {
      title: 'Aracısız ve Güvenilir Satış',
      description: 'İkinci el iş makinalarını arada aracı olmadan, doğrudan alıcılarla buluşturan iyiMakina.com\'da; ekspertiz raporlarını inceleyen alıcılar, istedikleri teklifi iyiMakina Güvencesiyle verebilirler.',
      icon: 'fa-solid fa-shield',
    },
    {
      title: 'Saatler İçinde Satış ve Devir',
      description: 'iyiMakina.com güvencesine sahip makinaları tek tık ile satın alan kullanıcılar; İster Hemen Al ile dakikalar içerisinde, ister Teklif Ver özelliğimiz ile makina sahibiyle pazarlık yaparak aradıkları makinaya güvenle sahip olabilirler.',
      icon: 'fa-solid fa-handshake',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="buy-now-process" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Hemen Al Süreci</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  <b>Hemen Al</b>
                  {' '}
                  yöntemi ile satışa çıkan makinalar, önceden belirlenmiş fiyatlarıyla birlikte satışa hazır durumdadır.
                  Makinaları satın almak isteyen alıcılar, makina ilan sayfasında belirtilen Hemen Al butonuna tıklayarak belirlenen fiyatı ödeyerek makinayı satın alabilirler.
                </p>
                <p>
                  <b>Teklif Ver</b>
                  {' '}
                  yöntemiyle satışa çıkan makinalar ise; alıcıların, ilgilendikleri makinaya istedikleri teklifi vermesine imkan tanımaktadır.
                  Makina ilan sayfasındaki Teklif Ver butonu aracılığıyla istedikleri teklifi verip, makina sahibi ile online pazarlık yapabilmektedir.
                </p>
                <p>
                  iyiMakina.com'da gerçekleşen Hemen Al ve Teklif Ver satışları, her makinanın ilan sayfasında belirtilen bitiş tarihine kadar devam eder.
                  Teklif veren kullacıların ödediği Teminat Bedeli aracılığıyla, manipülasyon olmadan, güvenli ve hızlı alım-satım gerçekleşir.
                </p>
              </div>
            </div>
            <div className="row mb-30 align-items-stretch">
              {
                _.map(items, (item, index) => (
                  <Feature key={index} data={item} />
                ))
              }
            </div>
            <BuyForOfferMachine />
            <ContactUs about="Hemen Al Süreciyle" />
          </div>
        </div>
      </div>
    </main>
  );
};

BuyNowProcess.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Hemen Al Süreci',
    },
  };
};

BuyNowProcess.Layout = Layout;

export default withTranslation('common')(BuyNowProcess);
